import { FC } from "react";
import Popup from "reactjs-popup";

interface CustomLoaderProps {
    isVisible: boolean;
}

const CustomLoader: FC<CustomLoaderProps> = (props) => {
    return (
        <Popup
            open={props.isVisible}
            modal
            overlayStyle={{ zIndex: 999999 }}
            closeOnDocumentClick={false}
            closeOnEscape={false}
        >
            <div className="flex justify-center">
                <div className="w-30 h-30 border-[16px] border-gray-200 border-t-[#6A4F3E] rounded-full fixed top-1/2 animate-spin-loader"></div>
            </div>
        </Popup>
    );
};

export default CustomLoader;
